module.exports = __webpack_public_path__ + "img/744.5d711063.jpg";